export default __webpack_public_path__ + "static/media/francoise-img.024ea0fd.png";